import axiosInstance from './axiosInstance';
import {
  DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR,
  DEFAULT_SPACEY_INSTRUCTION_MESSAGE_TEXT_COLOR,
  DEFAULT_SPACEY_LAUNCHER_GREETING,
} from '../components/Agent/constants/spaceyDefaults';
import { normalizeHexColor } from '../components/Agent/utils/instructionMessageBackground';

export const SPACEY_CONFIG_CODE = 'SPACEY_CONFIG';

const configCache = new Map();

export const extractSpaceyIconUrl = (payload) => {
  if (!payload) return null;
  const url = payload.config?.iconUrl ?? payload.iconUrl;
  if (typeof url === 'string' && url.trim()) {
    return url.trim();
  }
  return null;
};

export const extractSpaceyInstructionMessageColor = (payload) => {
  if (!payload) return null;
  const raw = payload.config?.instructionMessageColor ?? payload.instructionMessageColor;
  if (typeof raw === 'string' && raw.trim()) {
    return normalizeHexColor(raw.trim(), null);
  }
  return null;
};

export const extractSpaceyInstructionMessageTextColor = (payload) => {
  if (!payload) return null;
  const raw = payload.config?.instructionMessageTextColor ?? payload.instructionMessageTextColor;
  if (typeof raw === 'string' && raw.trim()) {
    return normalizeHexColor(raw.trim(), null);
  }
  return null;
};

export const extractSpaceyLauncherGreeting = (payload) => {
  if (!payload) return null;
  const raw = payload.config?.launcherGreeting ?? payload.launcherGreeting;
  if (typeof raw === 'string' && raw.trim()) {
    return raw.trim();
  }
  return null;
};

export const normalizeSpaceyConfig = (payload) => ({
  iconUrl: extractSpaceyIconUrl(payload),
  launcherGreeting: extractSpaceyLauncherGreeting(payload) || DEFAULT_SPACEY_LAUNCHER_GREETING,
  instructionMessageColor:
    extractSpaceyInstructionMessageColor(payload) || DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR,
  instructionMessageTextColor:
    extractSpaceyInstructionMessageTextColor(payload) || DEFAULT_SPACEY_INSTRUCTION_MESSAGE_TEXT_COLOR,
});

/**
 * Public read: per-market Spacey settings from UiConfig SPACEY_CONFIG.
 */
export const fetchSpaceyConfig = async (countryCode) => {
  const code = String(countryCode || 'LK').toUpperCase();
  if (configCache.has(code)) {
    return configCache.get(code);
  }

  try {
    const res = await axiosInstance.get(`ui/config/${code}`, {
      params: { code: SPACEY_CONFIG_CODE },
    });
    const normalized = normalizeSpaceyConfig(res?.data);
    configCache.set(code, normalized);
    return normalized;
  } catch (error) {
    if (error?.response?.status === 404) {
      const fallback = normalizeSpaceyConfig(null);
      configCache.set(code, fallback);
      return fallback;
    }
    const fallback = normalizeSpaceyConfig(null);
    return fallback;
  }
};

/** @deprecated Prefer fetchSpaceyConfig */
export const fetchSpaceyIconUrl = async (countryCode) => {
  const config = await fetchSpaceyConfig(countryCode);
  return config?.iconUrl ?? null;
};

export const clearSpaceyConfigCache = (countryCode) => {
  if (countryCode) {
    configCache.delete(String(countryCode).toUpperCase());
  } else {
    configCache.clear();
  }
};

/** @deprecated Use clearSpaceyConfigCache */
export const clearSpaceyIconCache = clearSpaceyConfigCache;
